import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/AnalyzeVideoContent.graphql';
import { Mutation, MutationanalyzeVideoContentArgs } from '../../__generated__/globalTypes';

export const useAnalyzeVideoContentMutation = (
  options?: MutationHookOptions<Mutation, MutationanalyzeVideoContentArgs>
) => {
  const [callAnalyzeVideoContent, result] = useMutation<Mutation, MutationanalyzeVideoContentArgs>(MUTATION, options);

  return { callAnalyzeVideoContent, ...result };
};

export type AnalyzeVideoContentMutationFunction = Mutation['analyzeVideoContent'];
